import React, { useState, useEffect } from 'react';

const API = 'https://aaktradex.in';
const KITE_LOGIN_URL = 'https://kite.zerodha.com/connect/login?api_key=i8zf5c1r04kyy0lr&v=3';

export default function KiteConnect({ token }) {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchStatus = async () => {
    try {
      const res = await fetch(`${API}/kite-status`);
      const data = await res.json();
      setStatus(data);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  useEffect(() => {
    fetchStatus();
    const t = setInterval(fetchStatus, 30000);
    return () => clearInterval(t);
  }, []);

  if (loading) return null;

  const connected = status?.authenticated;
  const balance = status?.balance;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      {connected ? (
        <div style={{
          display: 'flex', alignItems: 'center', gap: 6,
          padding: '5px 10px', borderRadius: 8,
          background: '#EAF3DE', border: '0.5px solid #C0DD97'
        }}>
          <div style={{ width: 7, height: 7, borderRadius: '50%', background: '#639922', animation: 'pulse 1.5s infinite' }} />
          <span style={{ fontSize: 12, color: '#3B6D11', fontWeight: 500 }}>Kite connected</span>
          {balance && balance.available_cash > 0 && (
            <span style={{ fontSize: 11, color: '#3B6D11' }}>
              | Rs {Math.round(balance.available_cash).toLocaleString('en-IN')}
            </span>
          )}
        </div>
      ) : (
        <button
          onClick={() => window.open(KITE_LOGIN_URL, '_blank', 'width=800,height=600')}
          style={{
            fontSize: 12, padding: '5px 12px', borderRadius: 8,
            border: '0.5px solid #F7C1C1', background: '#FCEBEB',
            color: '#A32D2D', cursor: 'pointer', fontWeight: 500,
            display: 'flex', alignItems: 'center', gap: 5
          }}
        >
          🔌 Connect Kite
        </button>
      )}
    </div>
  );
}
